import type { Attribution, Campaign } from "@shared/types";
import { findPrintedQrByLegacyPath } from "@shared/campaigns";

const ATTRIBUTION_KEY = "getonbus:first-attribution";
const safeCode = /^[A-Za-z0-9_-]{1,40}$/;
const batchCode = /^B\d{3,}$/;

function allowed(value: string | null, pattern = safeCode) {
  return value && pattern.test(value) ? value : undefined;
}

export function getAttribution(campaign: Campaign, location: Location): Attribution {
  const saved = sessionStorage.getItem(ATTRIBUTION_KEY);
  if (saved) {
    try {
      const parsed = JSON.parse(saved) as Attribution;
      if (parsed.campaignId === campaign.id) return parsed;
    } catch {
      sessionStorage.removeItem(ATTRIBUTION_KEY);
    }
  }

  const params = new URLSearchParams(location.search);
  const printed = findPrintedQrByLegacyPath(location.pathname);
  const attribution: Attribution = {
    partnerId: campaign.partnerId,
    organizationId: campaign.organizationId,
    campaignId: campaign.id,
    ambassadorId: allowed(params.get("amb")) ?? printed?.ambassadorId,
    printBatchId: allowed(params.get("batch"), batchCode) ?? printed?.printBatchId,
    assetId: allowed(params.get("asset")) ?? printed?.assetId,
    channel: allowed(params.get("channel")) ?? printed?.channel,
    landingRoute: location.pathname,
    visitId: crypto.randomUUID(),
    firstVisitAt: new Date().toISOString(),
  };
  sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(attribution));
  return attribution;
}
